/* eslint-disable no-undef */
export default {
  ApiUrl: API_URL,
};
